import React, { useEffect, useState } from 'react';
import styles from './CodeSection.module.less';
import { CodeBlock } from '@paypalcorp/developeruikit';
import { Button, CopyToClipboardIcon, DownloadIcon } from '@paypalcorp/pp-react';
import copy from 'copy-to-clipboard';
import JSZip from 'jszip';
import { trackButtonClick } from '../../../lib/fpti';
import classNames from 'classnames';

const CodeSection = ({ ecmContent: { code, name, filename, language, config } }) => {
  const [isCopyActive, setIsCopyActive] = useState(false);

  const handleCopy = () => {
    copy(code);
    setIsCopyActive(true);
    trackButtonClick('Copy', null, name);
  };

  useEffect(() => {
    if (isCopyActive) {
      setTimeout(() => {
        setIsCopyActive(false);
      }, 2000);
    }
  }, [isCopyActive]);

  const handleDownload = () => {
    const zip = new JSZip();

    const fileData = code;
    const blob = new Blob([fileData], { type: 'text/plain' });
    const file = filename || language;
    zip.file(file.toLowerCase(), blob);

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      const url = URL.createObjectURL(content);
      const link = document.createElement('a');
      link.download = 'code.zip';
      link.href = url;
      link.click();
    });
  };

  const enableDownload = config?.enableDownload;

  const wrapperClass = classNames(styles.wrapper, {
    [styles.wrapper_padding]: config?.container_padding
  });

  return (
    <div className={wrapperClass}>
      <div className={styles.top_bar}>
        <Button size="md" tertiary iconComponent={CopyToClipboardIcon} onClick={handleCopy}>
          {isCopyActive ? 'Copied' : 'Copy'}
        </Button>
        {enableDownload && (
          <Button
            size="md"
            tertiary
            iconComponent={DownloadIcon}
            onClick={handleDownload}
            className={styles.download_btn}
          />
        )}
      </div>
      <CodeBlock language="javascript">{code}</CodeBlock>
    </div>
  );
};

export default CodeSection;
